import { CommonProps, type PropsEditorProps } from "./common";

export function DateProps(props: PropsEditorProps): JSX.Element {
  // Date không có constraint phức tạp ở MVP — chỉ common props
  return <CommonProps {...props} />;
}
